export default __webpack_public_path__ + "static/media/logo.cd663661.png";